export const adminPrefix = (path: string) => `/admin/${path}`
